import React from 'react';
import { Award, TrendingUp, BarChart3, Target, AlertTriangle, Clock } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

export const ValidationStatsPanel = ({ validationStats }) => {
  if (!validationStats) return null;
  const v = validationStats;
  const hitRate = v.total_validated > 0 ? ((v.total_hits / (v.total_validated * 3)) * 100).toFixed(1) : 0;
  const exactHits = v.hit_details?.exact || 0;
  const partialHits = v.hit_details?.partial || 0;

  return (
    <div className="space-y-6" data-testid="validation-stats">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatMiniCard icon={Target} color="text-green-400" bg="bg-green-500/20" value={v.total_hits || 0} label="Aciertos Totales" />
        <StatMiniCard icon={BarChart3} color="text-blue-400" bg="bg-blue-500/20" value={`${hitRate}%`} label="Tasa de Acierto" />
        <StatMiniCard icon={Award} color="text-amber-400" bg="bg-amber-500/20" value={v.total_validated || 0} label="Sorteos Validados" />
        <StatMiniCard icon={TrendingUp} color="text-purple-400" bg="bg-purple-500/20" value={v.best_streak || 0} label="Mejor Racha" />
      </div>

      {v.recent_validations?.length > 0 && (
        <Card className="bg-gray-900 border-gray-800">
          <CardContent className="p-6">
            <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
              <Clock size={18} className="text-cyan-400" />
              Validaciones Recientes
            </h3>
            <div className="space-y-3">
              {v.recent_validations.slice(0, 10).map((val, idx) => (
                <div key={val.date || `val-${idx}`} className="flex items-center justify-between p-3 rounded-lg bg-gray-800/50 border border-gray-700/30">
                  <div>
                    <p className="text-white font-medium">{val.lottery_name}</p>
                    <p className="text-gray-500 text-xs">{val.date}</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex gap-1.5">
                      {val.predicted?.map((n, i) => (
                        <span key={`p-${i}`} className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                          val.matched?.includes(n) ? 'bg-green-500/30 text-green-400 ring-1 ring-green-500' : 'bg-gray-700 text-gray-400'
                        }`}>{n}</span>
                      ))}
                    </div>
                    <Badge className={val.hits > 0 ? 'bg-green-500/20 text-green-400' : 'bg-gray-700/50 text-gray-500'}>
                      {val.hits || 0} hit{val.hits !== 1 ? 's' : ''}
                    </Badge>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {(!v.recent_validations || v.recent_validations.length === 0) && (
        <Card className="bg-gray-900 border-gray-800">
          <CardContent className="p-8 text-center">
            <AlertTriangle size={32} className="mx-auto text-amber-400 mb-3" />
            <p className="text-gray-400">Sin validaciones aun. Las predicciones se validan automaticamente al llegar resultados.</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

const StatMiniCard = ({ icon: Icon, color, bg, value, label }) => (
  <Card className="bg-gray-900 border-gray-800">
    <CardContent className="p-4 text-center">
      <div className={`w-10 h-10 rounded-full ${bg} flex items-center justify-center mx-auto mb-2`}>
        <Icon size={20} className={color} />
      </div>
      <p className="text-2xl font-bold text-white">{value}</p>
      <p className="text-gray-500 text-xs">{label}</p>
    </CardContent>
  </Card>
);
